// © Microsoft Corporation. All rights reserved.

import { CommonStyles, CommonSuperAppStyles } from "@msnews/social-utils";

import { ComponentStyles } from "@microsoft/fast-jss-manager";
import { CopyrightFormStyles } from "./copyright-form/CopyrightForm.styles";
import { DesignSystem } from "@microsoft/fast-components-styles-msft";
import { FollowButtonStyles } from "./follow-button/FollowButton.styles";
import { FollowButtonSuperAppStyles } from "./follow-button/themes/superapp/FollowButtonSuperApp.styles";
import { GradientOverlayStyles } from "./common/gradient-overlay/GradientOverlay.styles";
import { MultiLoginPageStyles } from "./multi-login-page/MultiLoginPage.styles";
import { NotificationCardStyles } from "./common/notification/NotificationCard.styles";
import { NotificationTrayStyles } from "./common/notification/NotificationTray.styles";
import { OnboardingPageStyles } from "./onboarding-page/OnboardingPage.styles";
import { PopupStyles } from "./popup/Popup.styles";
import { PublisherSubscribeFollowButtonStyles } from "./publisher-subscribe-follow-button/PublisherSubscribeFollowButton.styles";
import { ProfileManageDataPageStyles } from "./profile/profile-manage-data-page/ProfileManageDataPage.styles";
import { ReactionBreakdownStyles } from "./reaction-breakdown/ReactionBreakdown.styles";
import { ReactionBreakdownSuperAppStyles } from "./reaction-breakdown/themes/superapp/ReactionBreakdownSuperApp.styles";
import { ReportMenuStyles } from "./common/report-menu/ReportMenu.styles";
import { ReportMenuSuperAppStyles } from "./common/report-menu/themes/superapp/ReportMenuSuperApp.styles";
import { SocialClassNameContract } from "./Social.classnames";

/**
 * The Social styles
 * @type {ComponentStyles<SocialClassNameContract, DesignSystem>}
 */
export const SocialStyles: ComponentStyles < SocialClassNameContract, DesignSystem > = (config: DesignSystem) => ({
    ...CommonStyles(config),
    ...ReportMenuStyles(config),
    ...PopupStyles,
    ...NotificationCardStyles(config),
    ...NotificationTrayStyles(config),
    ...FollowButtonStyles,
    ...ReactionBreakdownStyles(config),
    ...MultiLoginPageStyles,
    ...ProfileManageDataPageStyles(config),
    ...OnboardingPageStyles(config),
    ...GradientOverlayStyles(config),
    ...CopyrightFormStyles(config),
    ...PublisherSubscribeFollowButtonStyles(config),

    /** SuperApp Styles */
    ...CommonSuperAppStyles(config),
    ...FollowButtonSuperAppStyles(config),
    ...ReactionBreakdownSuperAppStyles(config),
    ...ReportMenuSuperAppStyles(config)
});